import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const navLinks = [
    { label: 'Início', path: '/' },
    { label: 'Sobre', path: '/sobre' },
    { label: 'Serviços', path: '/servicos' },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <>
      <nav
        className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
          scrolled
            ? 'bg-[#0B0B0D]/95 backdrop-blur-md border-b border-[#C9A96E]/10'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <img
              src="https://public.readdy.ai/ai/img_res/a0dfe006-6179-422d-9045-deb7cf8a960a.png"
              alt="LOPES BUSINESS Logo"
              className="h-10 w-auto object-contain"
            />
          </Link>

          {/* Desktop Nav Links */}
          <div className="hidden md:flex items-center gap-10">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-sans text-sm font-medium tracking-widest uppercase transition-all duration-300 whitespace-nowrap ${
                  isActive(link.path)
                    ? 'text-[#C9A96E]'
                    : 'text-white/80 hover:text-[#C9A96E]'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden md:flex items-center">
            <a
              href="https://wa.me/5547997236779"
              target="_blank"
              rel="nofollow noreferrer"
              className="font-sans text-sm font-medium tracking-widest uppercase border border-[#C9A96E] text-[#C9A96E] px-6 py-2.5 rounded-full transition-all duration-300 hover:bg-[#C9A96E] hover:text-[#0B0B0D] whitespace-nowrap cursor-pointer"
            >
              Fale com um Especialista
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <div
        className={`fixed inset-0 z-40 bg-[#0F172A]/98 backdrop-blur-lg transition-all duration-500 flex flex-col items-center justify-center ${
          menuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
      >
        <div className="flex flex-col items-center gap-10">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className="font-serif text-3xl font-light tracking-widest text-white/90 hover:text-[#C9A96E] transition-all duration-300 cursor-pointer"
            >
              {link.label}
            </Link>
          ))}
          <a
            href="https://wa.me/5547997236779"
            target="_blank"
            rel="nofollow noreferrer"
            className="mt-6 font-sans text-sm font-medium tracking-widest uppercase border border-[#C9A96E] text-[#C9A96E] px-8 py-3 rounded-full hover:bg-[#C9A96E] hover:text-[#0B0B0D] transition-all duration-300 cursor-pointer"
          >
            Fale com um Especialista
          </a>
        </div>
      </div>
    </>
  );
};

export default Navbar;
